<template>
    <div class="field">
        <div v-if="isActive" class="control" v-bind:class="{ 'is-loading': isLoading }">
            <input class="input is-small" v-model="carData.query.model_type_en" v-on:change="updateChassis()" type="text" >
        </div>
        <div v-else class="display-flex">
            <span>{{ carData.query.model_type_en }}</span><span v-if="!isSalesStaff" @click="makeEditable" class="pencil-edit" style="margin-left: 10px;"><i class="fa fa-pencil-alt"></i></span>
        </div>

    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'

    export default {
        props:['car'],
        data () {
            return {
                isLoading: false,
                isActive: false,
                carData:{
                    id: this.car.id,
                    query: {
                        model_type_en: this.car.model_type_en,
                    }
                }
            }
        },
        methods: {
            makeEditable() {
                this.isActive = true;
                return this.isActive
            },
            updateChassis() {
                this.isLoading = true;
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            },

        },
        computed: {
        isSalesStaff() {
            if (this.$store.getters.getUserRole === 'Sales Staff') {
                return true
            }
        }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/ChassisColumn.vue